import styled from "@emotion/styled";

export const Container = styled.div`
    height: auto;
    text-align: center;
    width: auto;

    .image-placeholder {
        max-width: 100%;
    }
`;
